export const isInternalLink = (url: string, host: string): false | {uri: string, locale: string} => {

	const formatMatch = url.match('/(.{2,4})/article/(.*)');
	if (url.includes(host) && formatMatch) {
		return {locale: formatMatch[1], uri: formatMatch[2]};
	}

	// legacy support for Wix articles
	const wixFormatMatch = url.match('/(.{2,4})(?:/.+)?/kb/(.*)');
	if (url.includes(host) && wixFormatMatch) {
		return {locale: wixFormatMatch[1], uri: wixFormatMatch[2]};
	}

	return false;
};
